import { useLoginUserPagePriv } from '@/auth/useLoginUserPagePriv';
import { useMainLayoutContext } from '@/layouts/MainLayout/MainLayoutContext';
import { flatSx } from '@local/ui';
import { Button, ButtonProps, IconButton, SxProps, Theme } from '@mui/material';
import { useEffect } from 'react';
import { useObservable } from 'react-use';

type Without<T, K> = Pick<T, Exclude<keyof T, K>>;

type Button_Type = 'button' | 'icon';
type Priv = 'C' | 'R' | 'U' | 'D';
type Props = Without<ButtonProps, 'size'> & {
  size?: ButtonProps['size'];
  readOnly?: boolean;
  privType: Priv;
  buttonType?: Button_Type;
};

const rootSx: SxProps<Theme> = {};

export default function PrivButton(props: Props) {
  const { sx, size = 'small', readOnly, privType, buttonType = 'button', ...rest } = props;
  const privList = useLoginUserPagePriv();
  const { sceneManager } = useMainLayoutContext();
  const currentPage = useObservable(sceneManager.observeCurrentSceneOrNull(), null);

  const disable =
    privList &&
    privList.priv
      .filter((el) => el.pageKey === currentPage?.pageKey)
      .find((el) => el.privId === privType);

  if (buttonType === 'icon') {
    return (
      <IconButton sx={flatSx(rootSx, sx, { display: !!disable ? 'auto' : 'none' })} {...rest} />
    );
  } else {
    return (
      <Button
        sx={flatSx(rootSx, sx, { display: !!disable ? 'auto' : 'none' })}
        {...rest}
        disabled={readOnly}
      />
    );
  }
}
